// Katalog volitelných zvuků pro Mercure push notifikace (2026-08-17, viz
// docs/superpowers/specs/2026-08-17-mercure-notifications-design.md).
// Nove polozky se pridavaji sem + soubor do src/assets/sounds/, zadna
// dalsi zmena (store/BE/UI) neni potreba.
export const NOTIFICATION_SOUNDS = [
  {key: 'ping', label: 'Ping', file: 'ping.mp3'},
  {key: 'telegram', label: 'Telegram', file: 'telegram.mp3'},
  {key: 'pikachu1', label: 'Pikachu 1', file: 'pikachu-1.mp3'},
  {key: 'pikachu2', label: 'Pikachu 2', file: 'pikachu-2.mp3'},
  {key: 'pikachu3', label: 'Pikachu 3', file: 'pikachu-3.mp3'},
  {key: 'oldschool1', label: 'Oldschool', file: 'oldschool-1.mp3'},
  {key: 'oldschool2', label: 'Oldschool 2', file: 'oldschool-2.mp3'},
];

// Prvni polozka v katalogu je zaroven vychozi/fallback (viz
// getNotificationSoundFile nize) - pro existujici ucty s uz ulozenym
// zastaralym klicem (napr. drivejsi 'default'/'classic', smazane
// 2026-08-17) se tak automaticky vyresi jako Ping, bez nutnosti DB migrace.
export const DEFAULT_NOTIFICATION_SOUND = 'ping';

export function getNotificationSoundFile(key) {
  const found = NOTIFICATION_SOUNDS.find((s) => s.key === key);
  return (found || NOTIFICATION_SOUNDS[0]).file;
}
